export const stringOrDash = str => str || '-';
